import {isNotNil} from 'ramda';

import type {OrderStateType} from '@dms/shared';

import {Nullish} from 'shared/web';

const NON_EDITABLE_SERVICE_ORDER_STATES: OrderStateType[] = [
  'LOCKED',
  'ARCHIVED',
  'CLOSED',
  'CANCELLED',
  'CORRECTING_FULLY',
];

export const isNonEditableServiceOrderState = (state: OrderStateType | Nullish) =>
  isNotNil(state) && NON_EDITABLE_SERVICE_ORDER_STATES.includes(state);
